import React from "react";
import { Col, Input, Row, Select, theme } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export default function ProductFilters({
  searchTerm,
  onSearchChange,
  categories,
  selectedCategories,
  onCategoriesChange,
}) {
  const { token } = theme.useToken();

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={12} md={8}>
        <Input
          placeholder="Buscar por nombre..."
          prefix={<SearchOutlined style={{ color: token.colorTextDisabled }} />}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          size="large"
        />
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Select
          placeholder="Categoría"
          mode="multiple"
          allowClear
          size="large"
          style={{ width: "100%" }}
          value={selectedCategories}
          onChange={onCategoriesChange}
          options={categories.map((c) => ({ value: c, label: c }))}
        />
      </Col>
    </Row>
  );
}
